import { render, staticRenderFns } from "./CheckLinkPerson.vue?vue&type=template&id=26b5df61&scoped=true&"
import script from "./CheckLinkPerson.vue?vue&type=script&lang=js&"
export * from "./CheckLinkPerson.vue?vue&type=script&lang=js&"
import style0 from "./CheckLinkPerson.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CheckLinkPerson.vue?vue&type=style&index=1&id=26b5df61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b5df61",
  null
  
)

export default component.exports